// extracted by mini-css-extract-plugin
export default {"root":"ycFZFS","line":"K4dlZl"};